function initNorton() {
  var dn = "automaticviral.com";
  var lang = "en";
  var tpt = "transparent";
  var vrsn_style = "WW";
  var splash_url = "https://trustsealinfo.websecurity.norton.com";
  var sslcenter_url = "https://www.websecurity.symantec.com/security-topics/what-is-ssl-tls-https";
  var seal_url = "https://seal.websecurity.norton.com";
  
  var u1 = splash_url + "/splash?form_file=fdf/splash.fdf&dn=" + dn + "&lang=" + lang;
  var u2 = seal_url + "/getseal?at=0&sealid=1&dn=" + dn + "&lang=" + lang + "&tpt=" + tpt;
  var u5 = sslcenter_url;
  var sopener;
  
  function vrsn_splash() {
    if (sopener && !sopener.closed) {
        sopener.focus();
    } else {
        tbar = "location=yes,status=yes,resizable=yes,scrollbars=yes,width=560,height=500";
        var sw = window.open(u1, 'VRSN_Splash', tbar);
        if (sw) {
            sw.focus();
            sopener = sw;
        }
    }
  }

  window.nortonSplash = function() {
    vrsn_splash();
  };

  $('.nortonButton').css({cursor: 'pointer'}).click(function(e) {
    e.preventDefault();
    vrsn_splash();
    return false;
  });

}

$(function() {
  initNorton();
});

